<template>
  <div>

    <template>
      <flight-info-departure :value="value"></flight-info-departure>
    </template>

    <template>
      <flight-info-arrival :value="value" :showCTOT="false"></flight-info-arrival>
    </template>

    <v-divider/>

    <flight-info-ac :value="value"></flight-info-ac>

    <v-divider/>

    <template v-if="value.pax">
      <flight-info-pax :value="value"></flight-info-pax>
    <v-divider/>
    </template>

    <flight-info-state :value="value"></flight-info-state>
  </div>
</template>

<script>

import FlightInfoDeparture from '@/components/FlightInfoDeparture'
import FlightInfoArrival from '@/components/FlightInfoArrival'
import FlightInfoPax from '@/components/FlightInfoPax'
import FlightInfoState from '@/components/FlightInfoState'
import FlightInfoAc from '@/components/FlightInfoAc'

export default {
  name: 'FlightInfo',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ({
  }),
  components: {
    FlightInfoDeparture, FlightInfoArrival, FlightInfoPax, FlightInfoState, FlightInfoAc
  },
  methods: {
  },
  computed: {
  }
}
</script>
